import { createRequestTypes } from 'common/websocket-redux';

export const UPLOAD_FAQ_LINKS = createRequestTypes(
  'upload-faq-links/UPLOAD_FAQ_LINKS',
);
